import React, { useEffect, useRef, useState } from 'react';

import { gsap } from 'gsap';

import parse from 'html-react-parser';
import classNames from 'classnames';
import ButtonLink from 'components/buttonLink/buttonLink';

//styles
import './topicsItem.scss';

export interface TopicsItemData {
    className: string;
    topic: string;
    headline: string;
    text: string;
    linkFile?: {
        label: string;
        file: {
            mediaItemUrl: string;
        };
    };
    linkExternal?: {
        label: string;
        url: string;
    };
}

interface Props extends TopicsItemData {
    isActive: boolean;
    index: number;
    onExpand: (index: number) => void;
}

const TopicsItem: React.FC<Props> = (props) => {
    // states
    const [activeHeight, setActiveHeight] = useState<Number>(0);
    // refs
    const innerRef = useRef<HTMLDivElement>(null);

    const isAnchorLink = (url: string) => {
        return url.startsWith('#');
    };

    const handleExpand = () => {
        if (!!props.linkExternal?.url && isAnchorLink(props.linkExternal.url)) {
            gsap.to(window, {
                duration: 1,
                scrollTo: props.linkExternal.url,
                onComplete: () => {
                    location.hash = props.linkExternal?.url;
                },
            });
            return;
        }
        props.onExpand(props.index);
    };

    // set active height on win resize
    useEffect(() => {
        const handleResize = () => {
            innerRef.current && setActiveHeight(innerRef.current.clientHeight);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [props.isActive]);

    return (
        <div className={classNames('topics-item', { 'is-active': props.isActive }, props.className)}>
            <div className="topics-item__header" onClick={handleExpand}>
                <h5 className="topics-item__topic">{props.topic}</h5>
                <h3 className="topics-item__headline typo-h-redline">{props.headline}</h3>
            </div>
            <div className="topics-item__collapse" style={{ height: props.isActive ? `${activeHeight}px` : '0' }}>
                <div className="topics-item__inner" ref={innerRef}>
                    <div className="topics-item__content">{!!props.text && parse(props.text)}</div>
                    <div className="grid-row">
                        {!!props.linkExternal?.label && (
                            <div className="grid-cell">
                                <ButtonLink {...props.linkExternal} />
                            </div>
                        )}
                        {!!props.linkFile?.label && (
                            <div className="grid-cell">
                                <ButtonLink {...props.linkFile} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <button className="topics-item__button link-text" onClick={handleExpand}>
                <span>Weiterlesen</span>
                <span>Schliessen</span>
            </button>
        </div>
    );
};

export default TopicsItem;
